// The purpose of this module is to pass axios instance from BWA IO to AccessTokenManager

import AccessTokenManager, {
  Acl,
  UserInfo,
} from "../accessTokenManager/AccessTokenManager";
import { AppDispatch, AppGetState } from "../store";
import config from "../config";
import { AxiosInstance } from "axios";
import { IBwaIoGateway } from "../io/ioGateway";

const getAccessTokenManagerInstance = (() => {
  let accessTokenManager: AccessTokenManager;
  return (axios: AxiosInstance): AccessTokenManager => {
    if (!accessTokenManager) {
      accessTokenManager = new AccessTokenManager(axios, {
        tokenUpdateOvertakeFactor: config.tokenUpdateOvertakeFactor,
        loginServiceUrl: config.endpoints.loginService,
      });
    }
    return accessTokenManager;
  };
})();

export const getSiteLevelToken = (customerId: string, siteId: string) => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<string> =>
  getAccessTokenManagerInstance(axios).getToken({
    customerId,
    siteId,
  });

export const getGlobalLevelToken = () => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<string> =>
  getAccessTokenManagerInstance(axios).getToken({
    customerId: null,
    siteId: null,
  });

export const getUserInfoUsingGlobalLevelToken = () => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<UserInfo> =>
  getAccessTokenManagerInstance(axios).getUserInfo({
    customerId: null,
    siteId: null,
  });

export const getAclUsingGlobalLevelToken = () => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<Acl> =>
  getAccessTokenManagerInstance(axios).getAcl({
    customerId: null,
    siteId: null,
  });

export const getAclUsingSiteLevelToken = (
  customerId: string,
  siteId: string,
) => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<Acl> =>
  getAccessTokenManagerInstance(axios).getAcl({
    customerId,
    siteId,
  });

export const forceUpdateSiteLevelToken = (
  customerId: string,
  siteId: string,
) => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<string> =>
  getAccessTokenManagerInstance(axios).forceUpdateToken({
    customerId,
    siteId,
  });

export const killSessionCookie = () => (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<void> => getAccessTokenManagerInstance(axios).logout();
